export default __webpack_public_path__ + "static/media/Right_Arrow.fc333e68.svg";